var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer center",class:{'opacity':_vm.islogin},staticStyle:{"justify-content":"center"}},[_c('p',[_vm._v("Copyright © 2018  西本新干线     沪ICP12025672号-2    沪公网安备 31010902001335号    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b929566","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base/footer/footer.vue
// module id = null
// module chunks = 